import type { CellSourceLocation } from 'quadratic-shared/typesAndSchemasDocuments';
import { atom } from 'jotai';

/**
 * State of the in-sheet Documents panel (browser + viewer for the team's
 * uploaded drive documents), docked to the right of the grid.
 *
 * `documentUuid` selects the document shown in the viewer; `null` shows the
 * browser list. It is kept across close/reopen within a file session so the
 * panel comes back where the user left it.
 *
 * `location` is a deep link into the document: set when the panel is opened from
 * a cell's source (indicator or history Source row), so the viewer can jump to
 * the page/row the cell's value came from and highlight it. Cleared on an
 * ordinary open, which should land at the top of the document.
 *
 * The panel is not exclusive with the left-hand panels (AI chat, stock data,
 * connection schemas) — a document is meant to stay open next to a chat about
 * it.
 */
export type DocumentsPanelState = {
  open: boolean;
  documentUuid: string | null;
  location?: CellSourceLocation;
};

export const defaultDocumentsPanelState: DocumentsPanelState = { open: false, documentUuid: null };

export const documentsPanelAtom = atom<DocumentsPanelState>(defaultDocumentsPanelState);
